import React, { useState } from 'react';
import OrangeButton from '../Components/buttons/orange-button';
import { Link } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '', toc: false });

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  return (
    <div className="min-h-screen bg-greenColor py-6">
      <div className="container flex flex-col  gap-4">
        <Link to={'/'} className="logo nav-logo-title !text-[#fff]">
          <img src="/images/icons/grad-img.svg" alt="grad" />
          IAMAI
        </Link>
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex w-full max-w-md flex-col gap-4 rounded-[16px] bg-white p-4 shadow-lg md:p-8">
            <h2 className="fredokaOne text-center text-[40px] font-normal leading-normal tracking-[-0.8px] text-[#012E33]">
              Login
            </h2>
            <form className="flex flex-col gap-4">
              <div>
                <input
                  type="email"
                  id="email"
                  placeholder="Email"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <div>
                <input
                  type="password"
                  id="password"
                  placeholder="Password"
                  className="w-full rounded-[8px] border border-[#DCDCDC] bg-[#F5F5F5] p-3 outline-none"
                />
              </div>
              <OrangeButton label={'Sign Up'} className="w-full" />
            </form>
            <div className="space-y-2">
              <div className="flex w-full items-center justify-center gap-3">
                <input
                  className=""
                  id="toc"
                  type="checkbox"
                  checked={formData.toc}
                  onChange={handleChange}
                />
                <label
                  htmlFor="toc"
                  className="space-x-3 text-base font-normal leading-normal text-[#012E33]"
                >
                  Accept Policies{' '}
                  <Link to={'/tos'} className="text-[#FC823E] underline">
                    Terms of use
                  </Link>
                  <Link to={'/privacy-policy'} className="text-[#FC823E] underline">
                    Privacy Policy
                  </Link>
                </label>
              </div>
              <p className="text-center text-[16px] font-semibold leading-normal tracking-[-0.32px] text-[#012E33]">
                Or continue using
              </p>
              <div className="text-center">
                <div className="flex flex-wrap justify-center gap-3 md:flex-nowrap">
                  <button
                    className={` fredoka mx-auto flex h-12 w-[100px] items-center justify-center rounded-2xl bg-[#4285F4] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] md:w-full`}
                  >
                    <img src="/images/icons/social-icons/FacebookLogo.svg" alt="" /> Facebook
                  </button>
                  <button
                    className={` fredoka  mx-auto flex h-12 w-[100px] items-center justify-center rounded-2xl bg-[#DC4E41] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]  md:w-full`}
                  >
                    <img src="/images/icons/social-icons/GoogleLogo.svg" alt="" /> Google
                  </button>
                  <button
                    className={`fredoka mx-auto flex h-12 w-[100px] items-center justify-center rounded-2xl bg-[#000000] px-6 py-2 font-[Fredoka] text-[16px] text-base font-medium leading-normal text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]  md:w-full`}
                  >
                    <img src="/images/icons/social-icons/AppleLogo.svg" alt="" /> Apple
                  </button>
                </div>
                <p className="mt-5 space-x-3 text-base font-semibold leading-normal text-[#012E33]">
                  Already have an account?{' '}
                  <Link to={'/login'} className="text-[#FC823E] hover:underline">
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
